import React from "react";
// React Bootstrap
import { Image } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const IconStyled = styled(Image)`
  width: 25px;
  height: 25px;
  display: inline-block;
  margin-right: 5px;
  cursor: pointer;
`;

// Componente que da estilos de icono a una imagen

const Icon = ({ ...props }) => {
    return <IconStyled {...props} />;
};

export default Icon;
